import localeDefinitions from "./locales.json";

export type MarketingLanguage = keyof typeof localeDefinitions;
export const MARKETING_LOCALES = localeDefinitions;
export const MARKETING_LANGUAGES = Object.keys(localeDefinitions) as MarketingLanguage[];

export function getMarketingLanguageFromPath(pathname: string): MarketingLanguage {
  const prefix = `/${pathname.split("/")[1]?.toLowerCase() ?? ""}`;
  return MARKETING_LANGUAGES.find(language => localeDefinitions[language].home === prefix) ?? "en";
}

export function marketingLanguagePrefix(language: MarketingLanguage): string {
  return language === "en" ? "" : localeDefinitions[language].home;
}

/**
 * The site language for one of the app's locales (Tolgee's language: "en", "es-ES", "pt-BR", "af-ZA", ...), so an
 * app screen can link to the public page in the viewer's language. English for anything else.
 */
export function getMarketingLanguageForProductLocale(productLocale: string | null | undefined): MarketingLanguage {
  const normalizedProductLocale = productLocale?.toLowerCase();
  const isLanguageOfThisLocale = (language: MarketingLanguage) =>
    localeDefinitions[language].productLocale.toLowerCase() === normalizedProductLocale;
  return MARKETING_LANGUAGES.find(isLanguageOfThisLocale) ?? "en";
}

export function isMarketingHomePath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, "").toLowerCase() || "/";
  return MARKETING_LANGUAGES.some(language => localeDefinitions[language].home === normalized);
}
